<template>
  <el-tree
    ref="tree"
    :data="treeData"
    :node-key="nodeKey"
    show-checkbox
    expand-on-click-node
    :default-checked-keys="defaultCheckedKeys"
    :default-expand-all="expandAll"
    highlight-current
    :props="defaultProps"
    @check="getKeys">
    <span
      slot-scope="{ node, data }"
      class="custom-tree-node">
      <span @click="nodeClick(node, data)">{{ node.label }}</span>

      <el-popover
        v-if="node.data.funcId === 100"
        placement="right"
        width="180"
        trigger="click">
        <el-checkbox-group
          v-model="data.checkedList">
          <el-checkbox
            v-for="item in data.operations"
            :key="item.operation"
            :label="item.operation">{{ item.operationName }}</el-checkbox>
        </el-checkbox-group>
        <el-link
          slot="reference"
          type="primary"
          :underline="false"
          style="margin-left: 10px;"
          icon="el-icon-edit">已选：{{ data.checkedList.length }}项</el-link>
      </el-popover>

    </span>
  </el-tree>
</template>
<script>
export default {
  name: 'CheckboxTree',
  components: {},
  props: {
    expandAll: {
      type: Boolean,
      default: true
    },
    treeData: {
      type: Array,
      default() {
        return []
      }
    },
    nodeKey: {
      type: String,
      default: 'id'
    },
    value: {
      type: Array,
      default() {
        return []
      }
    },
    defaultProps: {
      type: Object,
      default() {
        return {
          children: 'children',
          label: 'label'
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    defaultCheckedKeys: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    nodeClick(node, data) {
      console.log(node, data)
    },
    getKeys(data, checked) {
      this.defaultCheckedKeys = checked.checkedKeys
    },
    getCheckedNodes() {
      return this.$refs.tree.getCheckedNodes()
    }
  }
}
</script>
<style lang="stylus"></style>
